
enum TicketStatusEnum {
    "Pending" = 0,
    "Open" = 1,
    "Closed" = 2
}

export default TicketStatusEnum;